<div class="dialogHeight">
    <!-- <table class="borderedTable">
      <thead>
        <tr>
          <th *ngFor="let interest of interestsList">{{interest.name}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let interest of interestsList">
        </tr>
      </tbody>
    </table> -->
    <div class="popupHeader">
      <h2 mat-dialog-title>Your Interest</h2>
      <div class="buttonHeaderPopup" >
        <button id="module_profile_module_interest_update_dialog_1" mat-button mat-dialog-close class="btnCustom btn-outline" (click)="closeDialog(false)">Cancel</button>
      <button id="module_profile_module_interest_update_dialog_2" mat-button mat-dialog-close class="btnCustom btn-primary" *ngIf="this.data.editable" (click)="closeDialog(true)">Save</button>
      </div>
    </div>
   
    <div mat-dialog-actions >
     
    <div class="flex">
      <div class="popupDropdownColumn" *ngFor="let interest of interestsList">
        <div class="columnItemHeader">
      {{interest.name}} <sup>*</sup>
        </div>
        <div class="columnItem" *ngFor="let values of interest.interestValues;" >
          <div class="checkboxItem">
            <mat-checkbox [checked]="values.isChecked?values.isChecked:false" (click)="toggleValueCheck($event,values)" [disabled]="!this.data.editable">
  
            </mat-checkbox>
          </div>
          <div>
            {{values.product_name}}
          </div>
        </div>
      </div>
    </div>
  </div>
  